import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {changeCheckProjectRequest, editCheckRequest, getDetailedCheckRequest} from "../../../services/api";
import {showNotification} from "../../../utils/actionWrappers";
import i18next from "../../../services/language/i18next";
import useGetCheckData from "./useGetCheckData";
import {useActions} from "../../../store/actions";
import {resetCheckNameAction, setCheckNameAction} from "../../../store/actions/global";

const useCheckEditData = () => {
  const {id} = useParams();
  const {getCheckData, integrations, checkRules} = useGetCheckData(id);
  const [isProjectAdmin, setIsProjectAdmin] = useState(null);
  const [setCheckName, resetCheckName] = useActions([setCheckNameAction, resetCheckNameAction]);

  useEffect(() => {
    if (id) {
      let cancelled = false;

      getDetailedCheckRequest(id)
        .then(({data}) => {
          if (!cancelled) {
            setIsProjectAdmin(data.is_user_project_admin);
            setCheckName(data);
          }
        });

      return () => {
        cancelled = true;
        resetCheckName();
      };
    }
  }, [id, resetCheckName, setCheckName]);

  const editCheckData = async (checkData, isProjectChanged, isCheckInfoChanged) => {
    await isCheckInfoChanged && editCheckRequest(checkData, id);
    await isProjectChanged && changeCheckProjectRequest(id, {project: checkData.project});

    showNotification(
      i18next.t("notification:title.success", "Success!"),
      i18next.t("notification:message.updated.check", "Check has been successfully updated."),
      "success"
    );

  };

  return {
    getCheckData,
    editCheckData,
    integrations,
    checkRules,
    isProjectAdmin,
    id
  };
};

export default useCheckEditData;